import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/mock-auth-context';
import { NotificationProvider } from '@/contexts/notification-context';
import { useBranding } from '@/hooks/use-branding';
import {
  registerNavigate,
  unregisterNavigate,
} from '@/services/axios-interceptors';

export function RootLayout() {
  const navigate = useNavigate();
  const { logoUrl, coverUrl } = useBranding();
  const isBranded = Boolean(logoUrl) || Boolean(coverUrl);

  useEffect(() => {
    // Register the navigate function for axios interceptor
    registerNavigate(navigate);

    return () => {
      unregisterNavigate();
    };
  }, [navigate]);

  return (
    <AuthProvider>
      <NotificationProvider>
        <main
          className={`relative min-h-screen ${
            isBranded ? 'bg-secondary' : 'bg-primary'
          }`}
        >
          <Outlet />
        </main>
      </NotificationProvider>
    </AuthProvider>
  );
}
